/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
import { observable, reaction, makeObservable } from 'mobx'
import * as R from 'ramda'
import i18n from 'i18next'

import QListAPI from './QListAPI'
import QuestionLibraryAPI from '../QuestionLibrary/QuestionLibraryAPI'
import QListQuestion from '../Models/QListQuestion'
import QuestionPipeStore from './components/QuestionPipe/QuestionPipeStore'

const responseRequiredQuestions = ['RD', 'CH', 'TB', 'RT', 'SB', 'OD', 'SG', 'PC', 'DT', 'FM']
class QuestionLibraryStore {
    oid = 0

    rid = 0

    surveyTypes = [{ label: 'Select survey type', value: '' }]

    @observable industries = []

    @observable industriesDefault = [{ label: 'Select your industry', value: '' }]

    @observable eventTypesDefault = [{ label: 'Select event type', value: '' }]

    @observable eventTypes = []

    @observable industry = { label: 'Select your industry', value: '' }

    @observable eventType = { label: 'Select event type', value: '' }

    @observable surveyType = { label: 'Select survey type', value: '' }

    @observable respondentTypes = []

    @observable respondentTypesDefault = [{ label: 'Select respondent type', value: '' }]

    @observable respondentType = { label: 'Select respondent type', value: '' }

    @observable surveyTypesDefault = [{ label: 'Select survey type', value: '' }]

    @observable customCategoryIndustry = ''

    @observable customCategoryEventTypes = []

    @observable customCategoryRespondentTypes = []

    @observable isIndustryVisible = false

    @observable isEventTypeVisible = false

    @observable isSurveyTypeVisible = false

    @observable isRespondentTypeVisible = false

    @observable eventTypeShowDisabled = false

    @observable respondentTypeShowDisabled = false

    @observable addingMaxbi = false

    @observable questions = []

    @observable filteredList = []

    @observable loading = true

    guideAccordionContent = [
        {
            title: i18n.t('questionLibrary.gettingStartedPanel.itemHeader.stepOne'),
            content: i18n.t('questionLibrary.gettingStartedPanel.itemContent.stepOne'),
        },
        {
            title: i18n.t('questionLibrary.gettingStartedPanel.itemHeader.stepTwo'),
            content: i18n.t('questionLibrary.gettingStartedPanel.itemContent.stepTwo'),
        },
        {
            title: i18n.t('questionLibrary.gettingStartedPanel.itemHeader.stepThree'),
            content: i18n.t('questionLibrary.gettingStartedPanel.itemContent.stepThree'),
        },
    ]

    @observable questionTypesList = []

    @observable questionTypesListDefault = []

    @observable questionType = { label: 'Select question type', value: '' }

    @observable categoryTypes = []

    @observable categoryTypesDefault = []

    @observable categoryType = { label: 'Select question category', value: 0 }

    @observable questionLibraryLists = observable.map({})

    @observable questionLibraryFilteredList = []

    @observable selectedId = 'explori'

    productMap = {}

    @observable isMultiplesurveyTypes = false

    constructor(store, screen, disableReactions = false) {
        makeObservable(this)
        this.appStore = store
        this.api = new QListAPI(store.http)
        this.questionLibraryApi = new QuestionLibraryAPI(store.http)
        this.questionPipeStore = new QuestionPipeStore(store)
        this.http = store.http
        this.api.store = this
        this.additionalQuestionsUrl = '/v1/dashboard/question'
        this.screen = screen

        this.addReactions(disableReactions)
        store.refreshSurveyQList = () => this.filterQuestionLibraryList(this.selectedId)
    }

    addReactions = (disableReactions) => {
        if (disableReactions) return

        reaction(
            () => this.industry,
            () => {
                this.clearQuestionData()
                this.resetQuestionFilters()
                this.eventType = {}
                if (this.industry.value) {
                    this.setEventTypes()
                } else {
                    this.resetEventTypes()
                    this.isEventTypeVisible = false
                }
                this.validateFilterVisibility()
            },
        )

        reaction(
            () => this.eventType,
            () => {
                this.clearQuestionData()
                this.resetQuestionFilters()
                if (this.eventType.value) {
                    this.setSurveyTypes(this.eventType.value)
                    this.initQuestionTypes()
                } else {
                    this.resetRespondentTypes()
                    this.resetSurveyTypes()
                    this.isRespondentTypeVisible = false
                    this.isSurveyTypeVisible = false
                }
                this.validateFilterVisibility()
            },
        )

        reaction(
            () => this.surveyType,
            () => {
                this.clearQuestionData()
                this.resetQuestionFilters()
                if (this.surveyType.value) {
                    this.setRespondentTypes(this.surveyType.value)
                } else {
                    this.resetRespondentTypes()
                    this.isRespondentTypeVisible = false
                }
                this.validateFilterVisibility()
            },
        )

        reaction(
            () => this.respondentType,
            () => {
                this.resetQuestionFilters()
                if (this.respondentType.value) {
                    this.initQuestionTypes()
                }
            },
        )

        reaction(
            () => this.questionType,
            () => {
                if (!this.questionType.value) {
                    this.resetFilteredList()
                }
            },
        )
    }

    init = async () => {
        this.productMap = await this.getProdMap()
        await this.getCustomCategoryOptions()
        this.setIndustries()
        await this.getQuestionCategory()
    }

    toggleQuestionPiping = async (qlistQuestion) => {
        this.questionPipeStore.load(
            qlistQuestion,
            this.respondentType.value,
            this.eventType.value,
        )
    }

    getQuestionCategory = async () => {
        const categories = await this.api.getQuestionCategories()
        const questionCategory = categories.find((category) => category.description === 'UNCATEGORISED')
        this.questionCategoryId = R.pathOr(undefined, ['categoryType', 'value'], this) ? this.categoryType.value : questionCategory.categoryId
    }

    resetQuestionFilters = () => {
        this.resetFilteredList()
        this.resetQuestionType()
        this.resetCategoryTypes()
    }

    clearQuestionData = () => {
        this.questions = []
        this.filteredList = []
    }

    setIndustries = () => {
        const { oid, customCategoryIndustry } = this

        let clientIndustriesFiltered = []
        const industries = Object.values(R.pathOr({}, ['productMap'], this))

        if (oid === 8) {
            clientIndustriesFiltered = industries.filter((obj) => obj.value === customCategoryIndustry)
        } else {
            clientIndustriesFiltered = industries
        }

        this.isIndustryVisible = clientIndustriesFiltered.length > 1
        this.bindIndustries(clientIndustriesFiltered, this.isIndustryVisible)
    }

    setRespondentTypes = (value) => {
        const {
            eventType,
            isMultiplesurveyTypes,
        } = this

        let respondentTypesFiltered = []
        let repondentTypes = []
        const arr = []

        if (value === 'EM') {
            this.isRespondentTypeVisible = false
        } else {
            this.isRespondentTypeVisible = true
        }

        if (eventType.value !== 'CE3P' && isMultiplesurveyTypes) {
            const combinedRespondentTypes = Object.values(R.pathOr(
                {},
                [
                    'productMap',
                    this.industry.value,
                    'children',
                    this.eventType.value,
                    'children',
                ],
                this,
            ))

            combinedRespondentTypes.forEach((surveyType) => {
                arr.push(Object.values(surveyType.children))
            })
            repondentTypes = arr.flat(1)
            const removeDuplicates = R.uniqWith(R.eqBy(R.prop('value')))
            repondentTypes = removeDuplicates(repondentTypes)
        } else {
            repondentTypes = Object.values(R.pathOr(
                {},
                [
                    'productMap',
                    this.industry.value,
                    'children',
                    this.eventType.value,
                    'children',
                    this.surveyType.value,
                    'children',
                ],
                this,
            ))
        }

        respondentTypesFiltered = this.filterRespondentTypes(repondentTypes)
        this.respondentTypeShowDisabled = respondentTypesFiltered.length === 1
        this.bindRespondentTypes(respondentTypesFiltered, !this.respondentTypeShowDisabled)
    }

    setSurveyTypes = () => {
        const surveyTypes = Object.values(R.pathOr(
            {},
            ['productMap', this.industry.value, 'children', this.eventType.value, 'children'],
            this,
        ))

        this.isMultiplesurveyTypes = surveyTypes.length > 1

        this.bindSurveyTypes(surveyTypes, this.isMultiplesurveyTypes)
        this.setRespondentTypes()
    }

    setEventTypes = () => {
        const { oid, customCategoryEventTypes } = this

        let eventTypesFiltered = []
        const eventTypes = Object.values(R.pathOr({}, ['productMap', this.industry.value, 'children'], this))

        if (oid === 8 && !customCategoryEventTypes.includes('*')) {
            eventTypesFiltered = this.filterEventTypes(eventTypes)
        } else {
            eventTypesFiltered = eventTypes
        }

        this.eventTypeShowDisabled = eventTypesFiltered.length === 1
        this.isEventTypeVisible = true
        this.bindEventTypes(eventTypesFiltered, !this.eventTypeShowDisabled)
        this.bindQuestionTypes()
    }

    getPossibleParentQuestions = ({ questionId }) => {
        const index = this.filteredList.findIndex((q) => q.questionId === questionId)
        if (index <= 0) return []

        return this.filteredList.slice(0, index).map(({ name, questionId }) => ({
            value: questionId,
            label: name,
        }))
    }

    getParentOption = (parentId) => {
        if (R.isNil(parentId)) return null
        const parentQuestion = this.filteredList.find((q) => q.questionId === parentId)
        return parentQuestion
            ? {
                value: parentId,
                label: parentQuestion.name,
            } : {
                value: null,
                label: 'Unknown question',
            }
    }

    isInheritValid = (parentId, questionId) => {
        const childIndex = this.filteredList.findIndex((q) => q.questionId === questionId)
        const parentIndex = this.filteredList.findIndex((q) => q.questionId === parentId)

        return parentIndex >= 0 && parentIndex < childIndex
    }

    initQuestionTypes = () => {
        this.questionTypesList.forEach((item) => {
            switch (item.value) {
                case 'explori':
                    this.getExplori()
                    break

                case 'product':
                    // to be implemented
                    break

                case 'client':
                    this.getClient()
                    break

                case 'mandatory':
                    this.getMandatory()
                    break

                case 'recommended':
                    this.getRecommended()
                    break

                default:
                    break
            }
        })
    }

    getExplori = async () => {
        this.questionLibraryLists.set('explori', [])
        await this.getCategories()
    }

    getClient = async () => {
        this.questionLibraryLists.set('client', [])
        if (this.oid >= 6) {
            await this.getClientQuestions()
        } else {
            await this.getAvailableQuestions()
        }
    }

    getRecommended = () => {
        const { appStore } = this
        const { recommendedQuestions } = appStore
        this.questionLibraryLists.set('recommended', recommendedQuestions)
    }

    getMandatory = () => {
        const { appStore } = this
        const { mandatoryQuestions } = appStore
        this.questionLibraryLists.set('mandatory', mandatoryQuestions)
    }

    bindQuestionTypes = () => {
        const { oid, appStore } = this
        let questionTypes = []
        if (oid !== 7) {
            const nonSurveyTypes = [
                {
                    label: i18n.t('questionLibrary.searchPanel.questionList.questionTypes', { 1: 'Explori' }),
                    value: 'explori',
                },
                {
                    label: i18n.t('questionLibrary.searchPanel.questionList.questionTypes', { 1: R.path(['userData', 'clientName'], appStore) }),
                    value: 'client',
                },
            ]
            if (this.screen === 'surveyBuilder') {
                nonSurveyTypes.push(
                    {
                        label: i18n.t('questionLibrary.searchPanel.questionList.questionTypes', { 1: 'Mandatory' }),
                        value: 'mandatory',
                    },
                    {
                        label: i18n.t('questionLibrary.searchPanel.questionList.questionTypes', { 1: 'Recommended' }),
                        value: 'recommended',
                    },
                )
            }
            questionTypes = this.questionTypesListDefault.concat(nonSurveyTypes)
            this.questionTypesList = questionTypes
        } else {
            // to be implemented later according to survey builder
        }
    }

    resetFilteredList = () => {
        this.questionLibraryFilteredList = []
    }

    resetEventTypes = () => {
        this.eventTypes = this.eventTypesDefault
        this.eventType = this.eventTypesDefault[0]
    }

    resetRespondentTypes = () => {
        this.respondentTypes = this.respondentTypesDefault
        this.respondentType = this.respondentTypesDefault[0]
    }

    resetSurveyTypes = () => {
        this.surveyTypes = this.surveyTypesDefault
        this.surveyType = this.surveyTypesDefault[0]
    }

    resetCategoryTypes = () => {
        this.categoryType = this.categoryTypesDefault[0]
    }

    resetQuestionType = () => {
        this.questionType = this.questionTypesListDefault[0]
    }

    checkForSurveyTypes = (survey, type) => {
        const filteredSurvey = survey.some((obj) => obj.value === type)
        return filteredSurvey
    }

    validateFilterVisibility = () => {
        const {
            surveyType,
            eventType,
            oid,
            isMultiplesurveyTypes,
        } = this

        const eventTypeSelected = eventType.value
        const surveyTypeValue = surveyType.value

        this.isSurveyTypeVisible = isMultiplesurveyTypes

        if ((surveyTypeValue !== '' && eventTypeSelected) || (oid === 8 && eventTypeSelected)) {
            this.isRespondentTypeVisible = true
        } else {
            this.isRespondentTypeVisible = false
        }
    }

    setCustomCategoryOptions = (options) => {
        this.customCategoryIndustry = options.industry
        this.customCategoryEventTypes = options.productType.split(',')
        this.customCategoryRespondentTypes = options.respondentType.split(',')
    }

    filterEventTypes = (eventTypes) => {
        const result = this.customCategoryEventTypes.map((item) => eventTypes.filter((obj) => obj.value === item)[0])
        return result
    }

    filterRespondentTypes = (respondentTypes) => {
        const {
            oid,
            customCategoryRespondentTypes,
            eventType,
            industry,
            surveyType,
        } = this

        if (oid === 8 && !customCategoryRespondentTypes.includes('*')) {
            return this.customCategoryRespondentTypes.map((item) => respondentTypes.filter((obj) => obj.value === item)[0])
        }
        if (industry.value === 'EV') {
            return respondentTypes.filter((obj) => obj.value === 'VI' || obj.value === 'EX').sort().reverse()
        }
        if (eventType.value === 'CEEE' || eventType.value === 'CECE') {
            return respondentTypes.filter((obj) => obj.value === 'CEVI')
        }

        if (eventType.value === 'CE3P' && surveyType.value === 'PE') {
            return respondentTypes.sort().reverse()
        }
        return respondentTypes
    }

    bindIndustries = (industries, isMultipleOption) => {
        const mappedIndustries = industries.map(({ value, label }) => ({
            label,
            value,
        }))

        this.industries = isMultipleOption ? this.industriesDefault.concat(mappedIndustries) : mappedIndustries
        this.industry = this.industries[0]
    }

    bindEventTypes = (eventTypes, isMultipleOption) => {
        const mappedEventTypes = eventTypes.map(({ value, label }) => ({
            label,
            value,
        }))

        this.eventTypes = isMultipleOption ? this.eventTypesDefault.concat(mappedEventTypes) : mappedEventTypes
        this.eventType = this.eventTypes[0]
    }

    bindSurveyTypes = (surveyTypes, isMultipleOption) => {
        const mappedSurveyTypes = surveyTypes
            .filter((type) => type.value !== 'GE') // filter out general as an option
            .map(({ value, label }) => ({
                label,
                value,
            }))

        this.surveyTypes = isMultipleOption ? this.surveyTypesDefault.concat(mappedSurveyTypes) : mappedSurveyTypes
        this.surveyType = this.surveyTypes[0]
        this.addingMaxbi = this.surveyType.value === 'EM'
    }

    bindRespondentTypes = (respondentTypes, isMultipleOption) => {
        const mappedRespondentTypes = respondentTypes.map(({ value, label }) => ({
            label,
            value,
        }))

        this.respondentTypes = isMultipleOption ? this.respondentTypesDefault.concat(mappedRespondentTypes) : mappedRespondentTypes
        this.respondentType = this.respondentTypes[0]

        if (this.addingMaxbi && (this.eventTypeShowDisabled || this.isEventTypeVisible) && this.respondentTypeShowDisabled) {
            this.getQlist()
        }

        if (!this.addingMaxbi && (this.eventTypeShowDisabled || this.isEventTypeVisible) && this.respondentTypeShowDisabled) {
            this.getQlist()
        }
    }

    bindCategories = (categories) => {
        const mappedCategories = this.categoryTypesDefault.concat(categories.map((obj) => ({
            label: obj.description,
            value: obj.categoryId,
        })))
        this.categoryTypes = mappedCategories
    }

    getQuestionListDetails = async (questions) => {
        const that = this
        const questionDetails = []
        let res = null

        const additionalQuestions = await this.getAdditionalQuestionsList()
        const findQuestionId = (additionalQuestion, question) => (
            additionalQuestion.questionId.toUpperCase() === question.questionId
        )

        for (const question of questions) {
            if (question.questionType === 'RD' || question.questionType === 'TB' || question.questionType === 'SB') {
                res = await this.api.getQuestionDetails(question.questionId)
            }
            const q = new QListQuestion(question)
            q.qlistStore = that
            q.store = that.appStore
            q.recordId = that.rid
            q.http = that.http
            q.contextOid = this.oid
            q.modifiable = (
                this.oid === 8
                && question.qlistoid === 8
            ) || (
                question.qlistoid !== 8
                    && !(question.qlistoid < this.oid)
            )
            q.additionalQuestion = additionalQuestions.find((additionalQuestion) => findQuestionId(additionalQuestion, question))
            q.hasNumericCodes = question.questionType === 'RD' || question.questionType === 'TB' || question.questionType === 'SB' ? this.checkForNumericCodes(res, question.questionType) : false

            questionDetails.push(q)
        }
        return questionDetails
    }

    getProdMap = async () => {
        const { appStore } = this
        const { clientId } = appStore.userData
        const productMaps = await appStore.http.get(`/productmap/${clientId}?showAllLinked=true`)
        const prodMap = productMaps.reduce((obj, m) => {
            const newObj = { ...obj }
            // eslint-disable-next-line max-len
            newObj[m.industrycode] = newObj[m.industrycode] || { label: m.industryname, value: m.industrycode, children: {} }
            // eslint-disable-next-line max-len
            newObj[m.industrycode].children[m.producttypecode] = newObj[m.industrycode].children[m.producttypecode]
                || { label: m.producttypename, value: m.producttypecode, children: {} }
            // eslint-disable-next-line max-len
            newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode] = newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode]
                || { label: m.surveytypename, value: m.surveytypecode, children: {} }
            // eslint-disable-next-line max-len
            newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode].children[m.respondenttypecode] = newObj[m.industrycode].children[m.producttypecode].children[m.surveytypecode].children[m.respondenttypecode]
                || { label: m.respondenttypename, value: m.respondenttypecode }

            return newObj
        }, {})
        return prodMap
    }

    getCustomCategoryOptions = async () => {
        const { oid, rid } = this
        if (oid === 8) {
            const customCategoryOptions = await this.api.getCustomCategoryOptions(rid)
            this.setCustomCategoryOptions(customCategoryOptions)
        }
    }

    getAdditionalQuestionsList = async () => {
        const { appStore, appStore: { token } } = this

        return appStore.http.get(`${this.additionalQuestionsUrl}/list`, token)
            .then((res) => res.qsList)
            .catch((err) => {
                console.log('Error: ', err)
            })
    }

    checkForNumericCodes = (obj, questionType) => (questionType === 'RD' || questionType === 'SB'
        ? R.path(['question', 'optionSet', 'hasNumericCodes'], obj)
        : R.path(['question', 'optionSetX', 'hasNumericCodes'], obj))

    getQlist = async () => {
        const that = this
        const arr = []

        try {
            const questions = await this.api.getQlist(
                this.eventType.value,
                this.respondentType.value,
                this.oid,
                this.rid,
                {
                    vocabularyOid: this.vocabularyFilterOid,
                    industry: this.industry.value,
                },
                this.addingMaxbi ? 'EM' : this.surveyType.value,
            )
            that.questions = await this.getQuestionListDetails(questions)
            that.sgKpis = that.questions
                .filter((q) => ['BEH', 'COG'].includes(q.kpiType))
                .map((q) => q.kpiType)
            that.filterList()
        } catch (error) {
            console.log(error)
        }
    }

    addQuestion = (question) => {
        const { kpiType, title } = question
        // to be modified later when implementing add question functionality
        const q = new QListQuestion(true, true, title, false)

        if (['BEH', 'COG'].includes(kpiType) && !this.sgKpis.includes(kpiType)) {
            this.sgKpis.push(kpiType)
        }

        q.questionId = question.questionId
        q.clientId = this.appStore.tokenData.clientId
        q.oid = this.oid
        q.kpiType = kpiType
        q.recordId = this.rid
        q.qlistStore = this
        q.store = this.store
        q.producttypecode = this.eventType.value
        q.surveytypecode = this.addingMaxbi ? 'EM' : 'PE'
        q.respondenttypecode = this.respondentType.value
        q.mandatory = 1
        q.surveymandatory = 1
        q.priority = 0
        q.title = question.title
        q.http = this.http
        q.hasNumericCodes = 'Daniel'

        this.insertQuestion(q, (this.questions.length - 1))
    }

    findChildQuestion = (questionId) => this.questions.find((q) => q.parentId === questionId)

    editQuestion = async ({ newId, questionId, title }) => {
        const { appStore } = this
        const index = this.questions.findIndex((question) => (
            question.questionId.toUpperCase() === questionId.toUpperCase()
        ))

        if (index > -1) {
            const [question] = this.questions.splice(index, 1)
            const oldTitle = question.title
            question.title = title

            const restore = () => {
                question.title = oldTitle
                this.questions.splice(index, 0, question)
            }

            if (newId) {
                try {
                    const questionDeleted = await appStore.http.delete(`/qlist/${question.qlistId}`)
                    if (!questionDeleted) {
                        appStore.addNotification(null, 'There was an error deleting a question.', 'error')
                        restore()
                        return
                    }
                    question.questionId = newId
                    question.oid = this.oid
                    this.insertQuestion(question, index)
                } catch (e) {
                    console.error(e)
                    appStore.addNotification(null, 'There was an error cloning a question.', 'error')
                    restore()
                }
            } else {
                this.questions.splice(index, 0, question)
                this.getQlist()
            }
        }
    }

    insertQuestion = (question, dropIndex) => {
        console.log('HERE')
        question.mandatory = responseRequiredQuestions.includes(question.questionType)

        this.api.insert(question)
            .then((response) => {
                question.qlistId = response.insertId
                question.notDeletable = false
                this.questions.splice(dropIndex, 0, question)
                // temporarily commented to add this.getQlist() for experimental purposes. this.filterList() will be removed once tested successfully
                // this.filterList()
                this.getQlist()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    getPlaceholderTranslations = (filter) => {
        switch (filter) {
            case 'industry':
                return i18n.t('industrySelectPlaceholder', 'Select your industry')

            case 'eventType':
                return i18n.t('eventTypeSelectPlaceholder', 'Select event type')

            case 'surveyType':
                return i18n.t('surveyTypeSelectPlaceholder', 'Select survey type')

            case 'respondentType':
                return i18n.t('respondentTypeSelectPlaceholder', 'Select respondent type')

            case 'questionType':
                return i18n.t('questionTypePlaceholder', 'Select question type')

            case 'categoryType':
                return i18n.t('categoryTypePlaceholder', 'Select question category')

            default:
                return ''
        }
    }

    getQuestionDetails = async (questionId) => {
        const { appStore } = this

        try {
            const questionRes = await appStore.http.get(`/api/question/${questionId}/7`)
            return questionRes
        } catch (e) {
            const { addNotification } = appStore
            addNotification(null, 'There was an error obtaining additional question data. Please reload the page.', 'error')
        }
    }

    getQuestions = async () => {
        const { questionLibraryApi } = this

        const params = {
            origSurveyId: this.origSurveyId,
            category: this.categoryType ? this.categoryType.value : 0,
            respondentType: this.respondentType.value,
            productType: this.eventType.value,
            clientId: 1,
            isGlobal: 1,
            oid: 1,
            surveyType: this.addingMaxbi ? 'EM' : 'PE',
        }

        if (this.oid >= 6) {
            params.surveyType = this.surveyType.value
        }

        try {
            const questions = await questionLibraryApi.getQuestions(params)
            const list = await questions.reduce((arr, question) => {
                const q = new QListQuestion(question)
                q.clientId = 1
                q.oid = 1
                q.viewOnly = this.oid >= 6
                q.notDeletable = true
                q.contextOid = this.oid

                arr.push(q)
                return arr
            }, [])
            return list
        } catch (error) {
            console.log(error)
        }
    }

    getAvailableQuestions = async (explori) => {
        const { questionLibraryApi } = this
        if (!this.eventType?.value || !this.respondentType?.value) return
        await questionLibraryApi.getAvailableQuestions(explori, this.eventType.value, this.respondentType.value, this.categoryType?.value, 3)
            .then(async (questions) => {
                const list = questions.reduce((arr, question) => {
                    const q = new QListQuestion(question)
                    q.http = this.http
                    q.notDeletable = true
                    q.contextOid = this.oid
                    arr.push(q)
                    return arr
                }, [])
                const listName = explori ? 'explori' : 'client'
                this.questionLibraryLists.set(listName, list)
                this.filterQuestionLibraryList(listName)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    getClientQuestions = async () => {
        const { questionLibraryApi } = this

        await questionLibraryApi.getQuestions({
            origSurveyId: this.origSurveyId,
            surveyType: this.surveyType.value,
            respondentType: this.respondentType.value,
            productType: this.eventType.value,
            criteria: 'questionList',
            isActive: 1,
        })
            .then((questions) => {
                const list = questions.reduce((arr, question) => {
                    const q = new QListQuestion(question)
                    q.oid = 3
                    q.viewOnly = true
                    q.contextOid = this.oid

                    arr.push(q)
                    return arr
                }, [])
                this.questionLibraryLists.set('client', list)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    getCategories = async () => {
        const { appStore, questionLibraryApi } = this
        const options = {
            productType: this.eventType.value,
            respondentType: this.respondentType.value,
            surveyType: this.surveyType.value,
            clientId: appStore.userData.clientId,
            isGlobal: 1,
            surveyType: this.addingMaxbi ? 'EM' : 'PE',
        }

        const categories = await questionLibraryApi.getQuestionCategories(options)
        this.bindCategories(categories)
    }

    getQuestionList = () => this.questionLibraryLists.get(this.selectedId)

    handleIndustry = ({ label, value }) => {
        this.handleFilter('industry', { label, value })
    }

    handleEventType = ({ label, value }) => {
        this.addingMaxbi = false
        this.handleFilter('eventType', { label, value })
    }

    handleSurveyType = ({ label, value }) => {
        this.addingMaxbi = value === 'EM'
        this.handleFilter('surveyType', { label, value })
        this.getQlist()
    }

    handleRespondentType = ({ label, value }) => {
        this.addingMaxbi = false
        this.handleFilter('respondentType', { label, value })
        this.getQlist()
    }

    handleQuestionType = async ({ label, value }) => {
        this.handleFilter('questionType', { label, value })
        this.selectedId = value
        if (this.qSearch) {
            this.qSearch.clear()
        }
        this.resetCategoryTypes()
        const list = await this.getQuestions()
        this.questionLibraryLists.set('explori', list)
        this.filterQuestionLibraryList(value)
    }

    handleCategoryType = async ({ label, value }) => {
        this.handleFilter('categoryType', { label, value })
        await this.changeQlistCategory({ label, value })
    }

    handleFilter = (filter, obj) => {
        if (!R.isNil(obj.value)) {
            this[filter] = obj
        } else {
            switch (filter) {
                case 'categoryType':
                    this.resetCategoryTypes()
                    break
                case 'questionType':
                    this.resetQuestionType()
                    break
                case 'surveyType':
                    this.resetSurveyTypes()
                    break
                case 'eventType':
                    this.resetEventTypes()
                    break
                case 'respondentType':
                    this.resetRespondentTypes()
                    break
                default:
                    break
            }
        }
    }

    changeQlistCategory = async () => {
        const list = await this.getQuestions()
        this.questionLibraryLists.set('explori', list)
        this.filterQuestionLibraryList('explori')
    }

    filterList = () => {
        const searchString = this.listSearch ? this.listSearch.searchStr : ''
        const r = new RegExp(searchString, 'gi')
        this.filteredList = []
        const list = this.questions.filter((question) => question.name.match(r))
        this.filteredList = list
    }

    filterQuestionLibraryList = (listName, refresh = false) => {
        let list = this.getQuestionList()
        if (listName && this.selectedId === listName) {
            list = this.search(list, refresh)
            this.questionLibraryFilteredList = list
        }
    }

    search = (list, refresh = false) => {
        const { screen } = this
        const r = new RegExp(R.pathOr('', ['qSearch', 'searchStr'], this), 'gi')
        let newList = list.filter((question) => (question.title && question.title.match(r))
            || (question.questioncategory && question.questioncategory.match(r))
            || (question.surveytypename && question.surveytypename.match(r))
            || (question.respondenttypename && question.respondenttypename.match(r))
            || question.questiontype === this.qSearch.searchStr.toUpperCase())
        if (this.pageQuestions) {
            const keys = this.pageQuestions.map((key) => key.toUpperCase())
            newList = newList.filter((question) => keys.indexOf(question.questionId.toUpperCase()) === -1)
        } else if (this.questions && !refresh) {
            const keys = this.questions.map((question) => question.questionId.toUpperCase())
            newList = newList.filter((question) => keys.indexOf(question.questionId.toUpperCase()) === -1)
        }
        if (screen === 'surveyBuilder') {
            const { appStore } = this
            const questionIdsInSurvey = new Set(appStore.survey?.pages?.flatMap(
                (page) => (page.questions
                    ? page.questions.map((q) => q.questionId.toLowerCase())
                    : []
                ),
            ))
            newList = newList.filter((q) => !questionIdsInSurvey.has(q.questionId.toLowerCase()))
        }
        return newList
    }

    dropReorder = (sourceIndex, destinationIndex) => {
        const [question] = this.filteredList.splice(sourceIndex, 1)
        this.filteredList.splice(destinationIndex, 0, question)
        this.api.reorder((
            this.filteredList.reduce((arr, q) => arr.concat(q.qlistId), [])
        ))
    }

    drop = (dropIndex, question) => {
        question.notDeletable = false
        question.viewOnly = false
        question.mandatory = Boolean(question.mandatory)
        this.insertQuestion(question, dropIndex)
    }

    dropRemove = (index) => {
        const list = this.questionLibraryFilteredList.slice()
        const [question] = list.splice(index, 1)
        this.questionLibraryFilteredList = list
        return question
    }

    dropGet = (index) => this.questionLibraryFilteredList?.[index]
}

export default QuestionLibraryStore
